// NPM Imports
import React from "react";
import PropTypes from "prop-types";

// CSS Imports
// import signIn from "./signin.module.scss";

// Component Imports
import SAMLAuth from "../SAMLAuth";

function SignInSaml(props) {
  const {
    data: { email },
  } = props;

  return (
    <SAMLAuth title="Login with SAML-SSO" usedFor="SIGNIN" userName={email} />
  );
}

SignInSaml.defaultProps = {};

SignInSaml.propTypes = {
  data: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
};

export default SignInSaml;
